import Title from "../components/TheTitle.vue";
import { searchCouponBulkOperationHistory, getBrandsMaster, getCouponTargetProductsMaster, getStoresMaster, } from "../api";
import { Validation } from "../utils/validation";
import { FormatDate } from "../utils/formatDate";
import { Authorize } from "../utils/authorize";
export default {
    name: "couponBulkGrantHistory",
    data() {
        return {
            infoPage: 1,
            pageSize: 100,
            tableInfo: [],
            brandInfo: [],
            storeInfo: [],
            targetProduct: [],
            form: {
                coupon_code: "",
                grant_date_from: "",
                grant_date_to: "",
                coupon_name: "",
                target_product_id: "",
                brand_id: "",
                store_id: "",
                operator: "",
                grant_number_min: "",
                grant_number_max: "",
                is_deleted: "",
            },
        };
    },
    components: {
        Title,
    },
    computed: {
        infoTotalPages() {
            return Math.max(1, Math.ceil(this.tableInfo.length / this.pageSize));
        },
        pagedInfo() {
            const start = (this.infoPage - 1) * this.pageSize;
            return this.tableInfo.slice(start, start + this.pageSize);
        },
    },
    watch: {
        "form.brand_id": async function (newBrand) {
            if (!newBrand) {
                this.storeInfo = [];
                return;
            }
            try {
                const response = await getStoresMaster(newBrand);
                if (response.result?.code === 9) {
                    this.$store.commit("setMessages", response.result.messages);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                }
                else {
                    this.storeInfo = response.data.results;
                }
            }
            catch (err) {
                //
            }
        },
    },
    methods: {
        setInfoPage(p) {
            if (p < 1)
                p = 1;
            if (p > this.infoTotalPages)
                p = this.infoTotalPages;
            this.infoPage = p;
        },
        formatDate(value) {
            return FormatDate.withoutTime(value);
        },
        exportCsv() {
            if (!this.tableInfo.length) {
                this.$store.commit("setMessages", ["出力対象のデータが存在しません。"]);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
                return;
            }
            // 1) ヘッダを作成
            const header = [
                "一括付与ID",
                "クーポンコード",
                "付与日時",
                "クーポン名",
                "対象商品",
                "ブランド",
                "クーポン付与店舗",
                "担当者",
                "付与数",
                "削除済み",
            ];
            // 2) tableInfo から値を取得（空文字や null は空文字に）
            const rows = this.tableInfo.map((t) => [
                t.coupon_bulk_operation_history_id,
                t.coupon_code,
                this.formatDate(t.operation_date),
                t.coupon_name,
                t.target_product,
                t.brand,
                t.store,
                t.operator,
                t.grant_number,
                t.is_deleted,
            ]);
            // 3) CSV を作る
            const escapeCsv = (value) => {
                if (value == null)
                    return "";
                const v = String(value);
                return v;
            };
            const lines = [];
            lines.push(header.map(escapeCsv).join(","));
            for (const r of rows) {
                lines.push(r.map(escapeCsv).join(","));
            }
            let csvContent = lines.join("\r\n");
            // 4) Excel で文字化けしにくくするために UTF-8 BOM を付与（不要なら削除）
            const bom = "\uFEFF";
            const blob = new Blob([bom + csvContent], {
                type: "text/csv;charset=utf-8;",
            });
            // 5) ダウンロード処理
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            // ファイル名（任意）
            a.download = "クーポン一括付与履歴_検索結果.csv";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        },
        onClear() {
            this.form = {
                coupon_code: "",
                grant_date_from: "",
                grant_date_to: "",
                coupon_name: "",
                target_product_id: "",
                brand_id: "",
                store_id: "",
                operator: "",
                grant_number_min: "",
                grant_number_max: "",
                is_deleted: "",
            };
        },
        goToResult(id) {
            this.$router.push(`/couponGrantResult/${id}`);
        },
        goToDetail(couponCode) {
            this.$router.push(`/couponDetail/${couponCode}`);
        },
        async onSearch() {
            const params = {
                coupon_code: (this.form.coupon_code || null),
                grant_date_from: (this.form.grant_date_from || null),
                grant_date_to: (this.form.grant_date_to || null),
                coupon_name: (this.form.coupon_name || null),
                target_product_id: (this.form.target_product_id || null),
                brand_id: (this.form.brand_id || null),
                store_id: (this.form.store_id || null),
                operator: (this.form.operator || null),
                grant_number_min: (this.form.grant_number_min || null),
                grant_number_max: (this.form.grant_number_max || null),
                is_deleted: (this.form.is_deleted || null),
            };
            const errorMessage = this.validate(params);
            if (errorMessage) {
                this.$store.commit("setMessages", errorMessage);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
                return;
            }
            const response = await searchCouponBulkOperationHistory(null, params.coupon_code, "0", params.grant_date_from, params.grant_date_to, params.coupon_name, params.target_product_id, params.brand_id, params.store_id, params.operator, params.grant_number_min, params.grant_number_max, params.is_deleted);
            if (response.result?.code === 9) {
                this.$store.commit("setMessages", response.result.messages);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
            }
            else {
                this.tableInfo = response.data.results;
                this.infoPage = 1;
            }
        },
        validate(params) {
            // エラーメッセージを格納する配列
            const errors = [];
            // 桁数チェック
            errors.push(...Validation.digitsMax({
                key: "クーポンコード",
                value: params.coupon_code,
            }, 9));
            errors.push(...Validation.digitsMax({
                key: "クーポン名",
                value: params.coupon_name,
            }, 100));
            errors.push(...Validation.digitsMax({
                key: "担当者",
                value: params.operator,
            }, 100));
            errors.push(...Validation.digitsMax({
                key: "付与数min",
                value: params.grant_number_min,
            }, 10));
            errors.push(...Validation.digitsMax({
                key: "付与数max",
                value: params.grant_number_max,
            }, 10));
            // 属性チェック
            if (params.coupon_code) {
                errors.push(...Validation.isNotContainSymbols({
                    key: "クーポンコード",
                    value: params.coupon_code,
                }));
            }
            if (params.grant_number_min) {
                errors.push(...Validation.isInteger({
                    key: "付与数min",
                    value: params.grant_number_min,
                }));
            }
            if (params.grant_number_max) {
                errors.push(...Validation.isInteger({
                    key: "付与数max",
                    value: params.grant_number_max,
                }));
            }
            // 相関チェック
            if (params.grant_date_from &&
                params.grant_date_to &&
                params.grant_date_from > params.grant_date_to) {
                errors.push("付与日時のFromとToは、FromがToより小さくなるように入力してください。");
            }
            if (params.grant_number_min &&
                params.grant_number_max &&
                Number(params.grant_number_min) >= Number(params.grant_number_max)) {
                errors.push("付与数のminとmaxは、minがmaxより小さくなるように入力してください。");
            }
            if (errors.length > 0) {
                return errors;
            }
            return "";
        },
    },
    async mounted() {
        if (await Authorize.isExpired(this)) {
            const gBMResponse = await getBrandsMaster();
            if (gBMResponse.result?.code === 9) {
                this.$store.commit("setMessages", gBMResponse.result.messages);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
                return;
            }
            else {
                this.brandInfo = gBMResponse.data.results;
            }
            const gCTPMResponse = await getCouponTargetProductsMaster();
            if (gCTPMResponse.result?.code === 9) {
                this.$store.commit("setMessages", gCTPMResponse.result.messages);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
                return;
            }
            else {
                this.targetProduct = gCTPMResponse.data.results;
            }
        }
    },
};
